import { useCallback, useEffect, useRef, useState } from 'react';

export function useSidebarIsExpanded() {
   //removed HeaderContainer issue on render prop re-render
   const [isSideNavExpanded, setIsSideNavExpandedState] = useState(false);

   const onClickSideNavExpand = useCallback(() => {
      setIsSideNavExpandedState((prevIsSideNavExpanded) => !prevIsSideNavExpanded);
   }, [setIsSideNavExpandedState]);

   // reset sidebar expanded on resize
   const expandedRef = useRef<boolean>(isSideNavExpanded);

   useEffect(() => {
      expandedRef.current = isSideNavExpanded;
   }, [isSideNavExpanded]);

   useEffect(() => {
      let mounted = true;
      const onResize = () => {
         if (mounted && expandedRef.current) setIsSideNavExpandedState(false);
      };
      window?.addEventListener('resize', onResize);
      return () => {
         mounted = false;
         window?.removeEventListener('resize', onResize);
      };
   }, []);

   const onMainContentClick = useCallback(() => {
      setIsSideNavExpandedState(false);
   }, []);

   return {
      isSideNavExpanded,
      onClickSideNavExpand,
      onMainContentClick,
   };
}
